import { aliasesTokens } from "./colors";
export const theme = {
    colors: {
        ...aliasesTokens,
    },
    fonts: {
        sourceSansPro: "Source Sans Pro, sans-serif",
    },
    fontSizes: {
        "48": "3rem",
        "40": "2.5rem",
        "34": "2.125rem",
        "32": "2rem",
        "30": "1.875rem",
        "28": "1.75rem",
        "26": "1.625rem",
        "24": "1.5rem",
        "22": "1.375rem",
        "20": "1.25rem",
        "18": "1.125rem",
        "16": "1rem",
        "14": "0.875rem",
        "12": "0.75rem",
        "8": "0.5rem",
    },
    fontWeights: {
        bolder: "900",
        bold: "700",
        regular: "400",
        light: "300",
        extraLight: "200",
    },
    shadows: {
        "1": "0px 0px 8px rgba(51, 51, 51, 0.1)",
    },
    space: {
        "90": "5.625rem",
        "82": "5.125rem",
        "64": "4rem",
        "56": "3.5rem",
        "48": "3rem",
        "40": "2.5rem",
        "32": "2rem",
        "24": "1.5rem",
        "16": "1rem",
        "8": "0.5rem",
        "4": "0.25rem",
    },
    borderWidths: {
        "1": "1px",
        "2": "2px",
        "3": "3px",
        "4": "4px",
        "8": "8px",
    },
    lineHeights: {
        tightest: "1",
        tight: "1.30",
        medium: "1.50",
        distant: "1.70",
    },
    breakpoints: {
        small: "360px",
        medium: "768px",
        large: "1024px",
    },
    columns: {
        small: 4,
        medium: 8,
        large: 12,
    },
    gutter: {
        small: 16,
        medium: 16,
        large: 24,
    },
    safetyPadding: {
        small: 16,
        medium: 24,
        large: 67,
    },
};
//# sourceMappingURL=index.js.map